import gql from 'graphql-tag'

export default gql`
mutation uploadImgBase64($file: String!, $type: ImgType!, $id: ID!) {
	cashAssist {
		img: uploadImgBase64(file: $file, type: $type, id: $id) {
			id
			uid
			key
		}
	}
}`
